import BaseApi from './BaseApi'

class UserEventService extends BaseApi {
  async listEvents(dependentId) {
    return this.axios.get('/v1/user-events/', { params: { dependent_id: dependentId } })
  }

  async createEvent(dependentId, description, eventDate) {
    return this.doRequest('post', '/v1/user-events/', { dependent: dependentId, description, event_date: eventDate })
  }

  async updateEvent(eventId, description, eventDate) {
    return this.doRequest('patch', `/v1/user-events/${eventId}/`, { description, event_date: eventDate })
  }

  async deleteEvent(eventId) {
    return this.axios.delete(`/v1/user-events/${eventId}/`)
  }
}

export default UserEventService
